import { ExtractStatus } from './common.js';

export const Kind = 'EXTRACT_AUTHORIZATION_STATUS' as const;
export { ExtractStatus as Status };
